import { createFeature, createReducer } from '@ngrx/store';

import { eventItineraryReducers } from './event-itinerary.reducers';
import { eventItineraryInitialState } from './event-itinerary.state';

export const eventItineraryFeature = createFeature({
  name: 'jobV3EventItinerary',
  reducer: createReducer(eventItineraryInitialState, ...eventItineraryReducers),
});
